<template>
  <modal-window :show="show" @close="closeModal">
    <template v-slot:popup-title>Гарантия от поломок</template>
    <template v-slot:popup-content>
      <Transition name="success">
        <form
          v-if="!isSuccess"
          key="1"
          @submit.prevent="sendGaranty"
          class="form"
        >
          <div class="form-field">
            <p>Наименование</p>
            
            <input
              class="input"
              v-model="form.carName"
              placeholder="Наименование"
              type="text"
              disabled
            />
          </div>
          <div class="form-field">
            <p>VIN</p>
            <input
              class="input"
              v-model="form.vin"
              placeholder="VIN"
              type="text"
              disabled
            />
          </div>
          <div class="form-field">
            <p>Пробег</p>
            <input
              class="input"
              v-model="form.mileage"
              placeholder="Пробег"
              type="text"
              disabled
            />
          </div>
          <div class="form-field">
            <p>ИНН продавца</p>
            <input
              class="input"
              v-model="form.inn"
              placeholder="ИНН"
              type="text"
              disabled
            />
          </div>
          <div class="form-field">
            <p>Дата начала действия полиса</p>
            <VueDatePicker
              v-model="form.startDate"
              locale="ru-RU"
              :enable-time-picker="false"
              placeholder="Выберите дату"
              :auto-apply="true"
              :min-date="new Date()"
              format="dd.MM.yyyy"
            />
          </div>
          <div class="form-field">
            <p>Срок действия полиса</p>
            <input
              class="input"
              value="1 год"
              placeholder="Срок действия полиса"
              type="text"
              disabled
            />
          </div>

          <div class="form-field">
            <p>E-mail</p>
            <input
              class="input"
              v-model="form.email"
              placeholder="E-mail"
              type="email"
            />
            <p class="form-error" v-if="errors.email">{{ errors.email }}</p>
          </div>

          <div class="form-field">
            <p>Телефон</p>
            <InputMask
              v-model="form.phone"
              placeholder="Телефон"
              mask="+7 999 999-99-99"
            />
            <p class="form-error" v-if="errors.phone">{{ errors.phone }}</p>
          </div>

          <div
            class="text-center position-relative"
            :class="{ '--loading': isLoading }"
          >
            <button
              class="button --compact"
              type="submit"
              :class="{ '--loading': isLoading }"
            >
              Отправить
            </button>
            <Preloader v-if="isLoading" class="for-button" invert />
          </div>
        </form>
        <div v-else key="2" class="text-center">
          <p>Заявка успешно отправлена</p>
        </div>
      </Transition>
    </template>
  </modal-window>
</template>

<script setup lang="ts">
import ModalWindow from "~/components/page/modalWindow.vue";
import VueDatePicker from "@vuepic/vue-datepicker";
import { user } from "~/utils/user";
import InputMask from "primevue/inputmask";
import Preloader from "~/components/page/Preloader.vue";
import {
  isMobilePhone,
  isEmailValid,
  removeNonDigits,
} from "~/utils/validations";

const props = defineProps({
  item: {
    type: Object,
    default: () => ({}),
  },
});

const form = ref({
  carName: props.item.car.name,
  vin: props.item.car.vin,
  mileage: props.item.car.mileage,
  inn: props.item.sellerData.inn,
  startDate: new Date(),
  email: user.userInfo?.email || "",
  phone: user.userInfo?.phone || "",
});

const show = ref(false);

const showModal = () => {
  show.value = true;
};

const closeModal = () => {
  show.value = false;
};

const errors = ref({
  email: "",
  phone: "",
});

const validateForm = () => {
  let isValid = true;

  errors.value.email = "";
  errors.value.phone = "";

  if (!isEmailValid(form.value.email)) {
    errors.value.email = "Неверный формат e-mail";
    isValid = false;
  }

  if (!form.value.email) {
    errors.value.email = "Заполните e-mail";
    isValid = false;
  }

  if (!isMobilePhone(form.value.phone)) {
    errors.value.phone = "Неверный формат телефона";
    isValid = false;
  }

  if (!form.value.phone) {
    errors.value.phone = "Заполните телефон";
    isValid = false;
  }

  return isValid;
};

const isSuccess = ref(false);
const isLoading = ref(false);

const sendGaranty = async () => {
  const isValid = validateForm();

  if (!isValid) {
    return;
  }

  isLoading.value = true;

  const apiRequest = new ApiRequest(
    "post",
    `lots/deal/${props.item.id}/warranty`,
    null,
    {
      name: form.value.carName,
      vin: form.value.vin,
      mileage: form.value.mileage,
      sellerInn: form.value.inn,
      email: form.value.email,
      phone: form.value.phone,
      policyStart: form.value.startDate,
      policyTermMonths: 12,
    }
  );

  apiRequest.onSuccess((data) => {
    isSuccess.value = true;
    isLoading.value = false;
  });

  apiRequest.onError((error) => {
    console.log(error);
    isLoading.value = false;
  });

  await apiRequest.request();
};

defineExpose({
  showModal,
});
</script>

<style scoped>
.form {
  display: flex;
  flex-direction: column;
}
</style>
